export const getDigitalOnboarding = state => state.digitalOnboarding;